const state = {
    user: {
        id: "",
        access_token: "",
        email: "",
        email_verified_at: null
    },
};

const getters = {
    user: (state) => state.user,
};

const actions = {
    async doLogin({ dispatch, commit }, credentials) {
        return new Promise((resolve, reject) => {
            axios.post("/auth/login", credentials).then(
                (response) => {
                    // Setting the OAuth-based bearer token for all future Axios requests
                    axios.defaults.headers.common["Authorization"] = "Bearer " + response.data.access_token;

                    commit("setUserFromLogin", response.data);
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doLogout({ commit }) {
        return new Promise((resolve, reject) => {
            axios.post("/auth/logout").then(
                (response) => {
                    commit("unsetUser");
                    commit("setSubmissions", [], { root: true }); // Remove submission data if logging out as an admin
                    commit("setSubmission", {}, { root: true }); // Remove submission data if logging out as an admin
                    window.localStorage.clear();
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doRegisterUser({ dispatch, commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/auth/register", payload).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doGetUser({ dispatch, commit, rootState }, userId) {
        return new Promise((resolve, reject) => {
            axios.get("/user/" + userId).then(
                (response) => {
                    commit("setUser", response.data);
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doUserAcceptPrivacyPolicy({ dispatch, commit, rootState }) {
        let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
        return new Promise((resolve, reject) => {
            axios.post("/user/" + userId + "/accept-privacy-policy").then(
                (response) => {
                    commit("setUser", response.data);
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async sendForgotPasswordEmail({ dispatch, commit }, credentials) {
        return new Promise((resolve, reject) => {
            axios.post("/auth/password/email", credentials).then(
                (response) => {
                    resolve();
                },
                (error) => {
                    console.log(error);
                    reject();
                }
            );
        });
    },
    async resetPassword({ dispatch, commit }, credentials) {
        return new Promise((resolve, reject) => {
            axios.post("/auth/password/update", credentials).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doSubmitApplication({ dispatch, commit, rootState }, userId) {
        userId = rootState.submissions.submission.id ?? userId; // Using the submission user ID if we are coming from the Admin panel
        return new Promise((resolve, reject) => {
            axios.post("/user/" + userId + "/submit").then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async resendEmailVerificationEmail({ dispatch, commit }) {
        return new Promise((resolve, reject) => {
            axios.get("/auth/resend-verification-email").then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    reject();
                }
            );
        });
    },
};
const mutations = {
    unsetUser: (state) => {
        state.user = {
            id: "",
            access_token: "",
            email: "",
            loggedIn: false,
        };
    },
    setUserFromLogin: (state, userData) => {
        state.user = userData;
    },
    setUser: (state, userData) => {
        state.user = {
            ...userData,
            access_token: state.user.access_token,
        };
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
